import React from 'react';
interface ActivityItemProps {
  title: string;
  subtitle: string;
  status: string;
  type: 'campaign' | 'request';
}
export function ActivityItem({
  title,
  subtitle,
  status,
  type
}: ActivityItemProps) {
  return <div className="p-3 rounded-lg border border-gray-100 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-296">
      <div data-id="element-297">
        <div className="text-sm font-semibold text-gray-900" data-id="element-298">{title}</div>
        <div className="text-xs text-gray-500" data-id="element-299">{subtitle}</div>
      </div>
      {type === 'campaign' ? <div className="text-sm text-green-600 font-medium" data-id="element-300">{status}</div> : <div className="flex items-center gap-2" data-id="element-301">
          <button className="px-3 py-1 rounded-md border text-xs hover:bg-gray-100" data-id="element-302">
            Reject
          </button>
          <button className="px-3 py-1 rounded-md bg-violet-600 text-white text-xs hover:bg-violet-700" data-id="element-303">
            Accept
          </button>
        </div>}
    </div>;
}